module.exports = __webpack_public_path__ + "files/f89c0e64fbf97990bbc05e0a2e5a49c7.png";